import React from 'react';
import { SkinnableComponent } from '../../types/component-skin';
import ComponentSkinWrapper from '../skins/ComponentSkinWrapper';

/**
 * Create wrapper components for skinnable components
 * This file contains JSX code separated from registry.ts
 */

export function createSkinnableWrapper(skinnable: SkinnableComponent) {
  const { type, defaultSkin, defaultProps } = skinnable;
  
  const SkinnableWrapper: React.FC<any> = (props) => {
    // 🔍 DEBUG: Log all received props
    if (type === 'BOARD') {
      console.log('[SkinnableWrapper] Board props received:', {
        props,
        'props.skin': props.skin,
        'props.componentProps?.skin': props.componentProps?.skin,
        defaultSkin,
        type
      });
    }

    const selectedSkin = props.skin || props.componentProps?.skin || defaultSkin;


    // ComponentRenderer에서 전달된 props 구조를 적절히 처리
    // componentAdapters에서 생성된 props는 이미 올바른 구조를 가지고 있음
    const componentData = {
      id: props.id,
      type,
      props: {}, // ComponentData 인터페이스에서 필수 속성
      componentProps: {
        ...(defaultProps?.componentProps || {}),
        ...(props.componentProps || {}),
        skin: selectedSkin
      },
      data: props.data || defaultProps?.data || {},
      content: props.content || defaultProps?.content || {},
      style: props.style || defaultProps?.style || {}
    };
    
    return (
      <ComponentSkinWrapper
        component={skinnable}
        componentData={componentData}
        skinId={selectedSkin}
        mode="preview"
      />
    );
  };
  
  return SkinnableWrapper;
}

export function createSkinnableEditorWrapper(skinnable: SkinnableComponent) {
  const { type, defaultSkin, defaultProps } = skinnable;
  
  const SkinnableEditorWrapper: React.FC<any> = (props) => {
    const { id, isSelected, onSelect, onDelete, dragHandleRef, ...restProps } = props;
    const selectedSkin = restProps.skin || restProps.componentProps?.skin || defaultSkin;

    const componentData = {
      id,
      type,
      props: {}, // ComponentData 인터페이스에서 필수 속성
      componentProps: {
        ...(defaultProps?.componentProps || {}),
        ...(restProps.componentProps || {}),
        skin: selectedSkin
      },
      data: restProps.data || defaultProps?.data || {},
      content: restProps.content || defaultProps?.content || {},
      style: restProps.style || defaultProps?.style || {}
    };
    
    const editorProps = {
      isSelected,
      onSelect,
      onEdit: () => console.log(`Edit ${type} component`),
      onDelete,
      dragHandleProps: { ref: dragHandleRef }
    };
    
    return (
      <div 
        style={{ 
          position: 'relative',
          cursor: 'move'
        }}
        onClick={onSelect}
      >
        {isSelected && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            border: '2px solid #007bff',
            pointerEvents: 'none',
            zIndex: 1000
          }} />
        )}
        
        <ComponentSkinWrapper
          component={skinnable}
          componentData={componentData}
          skinId={selectedSkin}
          mode="editor"
          editorProps={editorProps}
        />
      </div>
    );
  };
  
  return SkinnableEditorWrapper;
}